import { FontsService } from './../../services/fonts.service';
import {LanguageService} from './../../services/language.service';
import { Component, OnInit,EventEmitter,Output } from '@angular/core';
import { StateService} from '../../services/state.service';
import { EventService } from '../../services/event.service';


@Component({
  selector: 'app-eventfilter',
  templateUrl: './eventfilter.component.html',
  styleUrls: ['./eventfilter.component.scss']
})
export class EventfilterComponent implements OnInit {
  data: any = [];
  statelist: any;
  selectedstate;
  isWebinar: boolean;
  islive: boolean;
  language:any;
  eventlist: any;
  defaultSize: number;
  // styleObject: any;
  // styleObject1: any;
  // styleObject2: any;
 // size = 16;
 @Output() outputbystate: EventEmitter<Array<Event>> = new EventEmitter();

  constructor(private languageService:LanguageService,private stateService: StateService, private eventservice: EventService, private fontService: FontsService) {
    this.eventlist = this.getEventsList();
    // this.defaultSize = formService.getSize;
   }

  ngOnInit() {

    this.language='english';
    this.stateService.getStates().subscribe((response: any) => {
           this.statelist = response.data.data;
           console.log(this.statelist);
    }, (error) => {console.log(error); }

    );

    this.isWebinar = true;
    this.islive = true;
   }

  findevent() {
    // this.eventservice.getbyfilter(this.eventlist, this.selectedstate, this.isWebinar, this.islive);
    this.eventservice.getEventsByFilter(this.selectedstate).subscribe((res) => {
      console.log("Api returned");
      this.eventservice.emitEvent(res)
    });    
  }
  clickWebinar() {
    this.isWebinar = !this.isWebinar;
  }
  clickLive() {
    this.islive = !this.islive;
  }
  getEventsList() {
    this.eventservice.getEvents().subscribe((res) => {
      this.eventlist = res;
    });
  }

  public fontDecrease() {
    // this.styleObject = {
    //   'font-size': (this.fontService.decreaseSize() - 6) +  'px'
    // };
    // this.styleObject1 = {
    //   'font-size': (this.fontService.decreaseSize() - 9) +  'px'
    // };
    // this.styleObject2 = {
    //   'font-size': (this.fontService.decreaseSize()) +  'px'
    // };
    this.fontService.decreaseSize();
  }

  public fontIncrease() {
    // this.styleObject = {
    //   'font-size': (this.fontService.increaseSize() + 6) +  'px'
    // };
    // this.styleObject1 = {
    //   'font-size': (this.fontService.increaseSize() + 9) +  'px'
    // };
    // this.styleObject2 = {
    //   'font-size': (this.fontService.increaseSize()) +  'px'
    // };
    this.fontService.increaseSize();
  }

  // public styleObject = (): any => {

  //   const styles = {
  //     'font-size': (this.formService.increaseSize() + 6) +  'px'
  //   };
  //   return styles;
  //   // return ({
  //   //   'font-size': (this.formService.increaseSize() + 6) +  'px'
  //   // });
  // }

    public headerStyleObject = (): any => {
      return this.fontService.getHeaderStyleObject();
    }

    public spanPinkStyleObject = (): any => {
      return this.fontService.getSpanPinkStyleObject();
    }

    public header3StyleObject = (): any => {
      return this.fontService.getHeader3StyleObject();
    }

    onLanguage(language){

      if(language == 'english'){

        this.language='english';
        this.languageService.changeLanguage('english');
        
      } else if (language == 'spanish' ){

              this.language='spanish';
             this.languageService.changeLanguage('spanish');
        }

    }
  }
